import { connect } from 'react-redux';
import EventDialog from '../../../pages/Admin/EventManagement/EventDialog';
import {
    CreateEventRequested,
    ClearCreateEvent,
    EditEventRequested,
    ClearEditEvent,
    GetDetailEventRequestd,
    ClearGetDetailEvent,
} from '../../../actions/EventManagement';
import { ClearEventZone, GetZonesRequested } from '../../../actions/CommonOptions';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    createSuccess: state.eventManagement.createEvent.success,
    createErrors: state.eventManagement.createEvent.errors,
    editSuccess: state.eventManagement.editEvent.success,
    editErrors: state.eventManagement.editEvent.errors,
    getDetailEvent: state.eventManagement.detailEvent.data,
    getDetailSuccess: state.eventManagement.detailEvent.success,
    getDetailErrors: state.eventManagement.detailEvent.errors,
    eventZones: state.commonOptions.zones.data,
    zonesStatus: state.commonOptions.zonesStatus.data.registered_status,
    role: state.auth.credential.data.role,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCreateEvent: (params) => {
        dispatch(CreateEventRequested(params));
    },
    fetchEditEvent: (params) => {
        dispatch(EditEventRequested(params));
    },
    fetchClearCreateEvent: () => {
        dispatch(ClearCreateEvent());
    },
    fetchClearEditEvent: () => {
        dispatch(ClearEditEvent());
    },
    fetchGetDetailEvent: (params) => {
        dispatch(GetDetailEventRequestd(params));
    },
    fetchClearGetDetailEvent: () => {
        dispatch(ClearGetDetailEvent());
    },
    fetchEventZones: (params) => {
        dispatch(GetZonesRequested(params));
    },
    clearEventZone: () => {
        dispatch(ClearEventZone());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(EventDialog);
